import * as React from 'react';
import { Checkbox, FormControl } from 'react-bootstrap';
import { IConfirmDashDonation } from '@nkr/models/index';
import MaskedInput from "react-maskedinput";

interface IProps {
    data: IConfirmDashDonation,
    isConfirmChecked: boolean,
    isDenyChecked: boolean,
    valid: boolean,
    onSurgeryCompletedDateTimeChange: (id:number, value: string) => void,
    onConfirmChecked: (id: number) => void,
    onDenyChecked: (id: number) => void
}

class Row extends React.Component<IProps, {}> {
    handleSurgeryCompletedDateTimeChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.props.onSurgeryCompletedDateTimeChange(this.props.data.id, e.currentTarget.value);
    }

    render = () => {
        return (
            <tr>
                <td><a href={`/center/${this.props.data.centerId}/donors/donor-intake/details/${this.props.data.id}`} target='_blank'>View</a></td>
                <td>{this.props.data.firstName}</td>
                <td>{this.props.data.lastName}</td>
                {/* <td>{this.props.data.surgeryCompletedDateTime}</td> */}
                <td>
                    <MaskedInput
                        className='form-control'
                        mask='11/11/1111'
                        placeholder='mm/dd/yyyy'
                        style={{ borderColor: this.props.valid ? '#ccc' : '#a94442' }}
                        value={this.props.data.surgeryCompletedDateTime}
                        onChange={this.handleSurgeryCompletedDateTimeChange}
                    />
                </td>
                <td><Checkbox style={{ marginTop: 0, marginBottom: 0 }} checked={this.props.isConfirmChecked} onClick={() => this.props.onConfirmChecked(this.props.data.id)} /></td>
                <td><Checkbox style={{ marginTop: 0, marginBottom: 0 }} checked={this.props.isDenyChecked} onClick={() => this.props.onDenyChecked(this.props.data.id)} /></td>
            </tr>
        )
    }
}

export default Row;